import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicDropdown, NotifyOutsideClick } from 'core/components';
import { Loader, DatePicker } from 'core/components';
import { Button } from '@progress/kendo-react-buttons';
import moment from 'moment';

const OrderDateRangeFilterTemplate = ({
	orderDateRangeViewStore: {
		form,
		loading,
		dateFormat,
		onDateInput,
		customDateRange,
		closeCustomDateRange,
		dateFilterDropdownStore,
	},
	t,
}) => {
	if (loading) return <Loader />;
	return (
		<div className="flex--primary flex--align--middle pos--rel spc--right--med h--50">
			<BaasicDropdown
				dropdownStore={dateFilterDropdownStore}
				placeholder={t('ORDERVIEW.PLACEHOLDER.DATERANGESELECT')}
				className="w--200--px"
				isSearchable={false}
			/>
			{customDateRange && (
				<NotifyOutsideClick action={() => closeCustomDateRange()}>
					<div className="header__profile--csv">
						<div className={'header__profile--dropdown' + (customDateRange ? ' active' : '')}>
							<div className="spc--bottom--sml">
								<DatePicker field={form.$('dateRangeStart')} format={dateFormat} />
							</div>
							<div className="spc--bottom--sml">
								<DatePicker field={form.$('dateRangeEnd')} format={dateFormat} />
							</div>
							<div className="type--right">
								<Button
									className="btn btn--med btn--secondary"
									onClick={() => onDateInput()}
									type="button"
									disabled={
										form.$('dateRangeStart').value == '' ||
										form.$('dateRangeStart').value === undefined ||
										form.$('dateRangeEnd').value == '' ||
										form.$('dateRangeEnd').value === undefined ||
										!moment(form.$('dateRangeStart').value).isValid() ||
										!moment(form.$('dateRangeEnd').value).isValid()
									}
								>
									{t('SEARCH')}
								</Button>
							</div>
						</div>
					</div>
				</NotifyOutsideClick>
			)}
		</div>
	);
};

export default defaultTemplate(OrderDateRangeFilterTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/OrderDateRangeFilterTemplate.jsx